import { useMemo } from "react";
import { Box, SxProps } from "@mui/material";
import { COLORS, Text } from "@asayinc/component-library";
import { MessageStatus } from "../../../../types/Messages";
import { EventStatusOptions } from "../../../../types/Events";

interface IProps {
  messageStatus?: MessageStatus | EventStatusOptions;
  sx?: SxProps;
}

/**
 * given a messageStatus, return the color and text to go with it
 */
export const getBadgeData = (
  messageStatus?: MessageStatus | EventStatusOptions
) => {
  switch (messageStatus) {
    case MessageStatus.Attached:
    case MessageStatus.Attaching:
    case MessageStatus.Fetched:
    case MessageStatus.Fetching:
    case MessageStatus.ReadyForFetching:
    case MessageStatus.RefreshingIndex:
    case MessageStatus.Sent:
      return {
        color: COLORS.DATA_VIZ_DARK_GREEN,
        text: "Sent",
      };
    case EventStatusOptions.ACTIVE:
      return {
        color: COLORS.DATA_VIZ_DARK_GREEN,
        text: "Active",
      };
    case MessageStatus.Draft:
    case EventStatusOptions.DRAFT:
      return {
        color: COLORS.DOLPHIN,
        text: "Draft",
      };
    case MessageStatus.PendingApproval:
    case EventStatusOptions.PENDING:
      return {
        color: COLORS.DATA_VIZ_GOLD,
        text: "Pending approval",
      };
    case MessageStatus.Scheduled:
      return {
        color: COLORS.DATA_VIZ_GIGAS,
        text: "Scheduled",
      };
    case EventStatusOptions.PUBLISHED:
      return {
        color: COLORS.DATA_VIZ_SUSHI,
        text: "Published",
      };
    case EventStatusOptions.APPROVED:
      return {
        color: COLORS.DATA_VIZ_GIGAS,
        text: "Approved",
      };
    case EventStatusOptions.COMPLETED:
      return {
        color: COLORS.P_DISABLED,
        text: "Ended",
      };
    default:
      return null;
  }
};

const StatusBadge = ({ messageStatus, sx }: IProps) => {
  const badgeData = useMemo(() => getBadgeData(messageStatus), [messageStatus]);
  // if no badge for status return nothing
  if (!badgeData) {
    return null;
  }

  return (
    <Box
      component="span"
      bgcolor={badgeData?.color}
      borderRadius={4}
      px={3}
      height="30px"
      data-testid="status-badge"
      alignSelf="flex-start"
      display="flex"
      alignItems="center"
      sx={sx}
    >
      <Text variant="subtitle3" shade="light">
        {badgeData?.text}
      </Text>
    </Box>
  );
};

export default StatusBadge;
